<div class="demo-banner" role="status">
  <span class="demo-banner-tag">
    <nz-icon nzType="experiment" nzTheme="outline"></nz-icon>
    演示环境
  </span>

  @if (errorMessage()) {
    <span class="demo-banner-error">{{ errorMessage() }}</span>
  }

  <button
    nz-button
    nzSize="small"
    class="demo-banner-reset"
    [nzLoading]="resetting()"
    (click)="reset()"
  >
    重置
  </button>
</div>
